import { useContext } from "react";
import RoomsList from "../components/RoomsList";
import { Context } from "../context/Context";
import PlanningMenu from "../components/PlanningMenu";

const MobileTopMenu = ({ children }) => {
  const { page } = useContext(Context);

  return (
    <aside
      id="layout-menu"
      className={
        page.slug == "settings" ||
        page.slug == "backup-management" ||
        page.slug == "about-us" ||
        page.slug == "profile" ||
        page.slug == "devices" ||
        page.slug == "help"
          ? "d-none"
          : "layout-menu-horizontal menu-horizontal menu bg-menu-theme flex-grow-0 d-block d-lg-none position-fixed py-1"
      }
      style={{ top: "0" }}
    >
      {page.slug !== "settings" &&
      page.slug !== "backup-management" &&
      page.slug !== "about-us" &&
      page.slug !== "profile" &&
      page.slug !== "devices" &&
      page.slug !== "help" ? (
        <style>
          {`
        .layout-navbar-fixed .layout-wrapper:not(.layout-without-menu) .layout-page {
            padding-top: 35px !important;
        }

        @media (min-width: 992px) {
            .layout-navbar-fixed .layout-wrapper:not(.layout-without-menu) .layout-page {
                padding-top: 0 !important;
            }
        }
        `}
        </style>
      ) : null}

      <div className="container-xxl d-flex h-100">
        {page.slug == "home" ? <RoomsList /> : null}
        {page.slug == "planning/scenario" ||
        page.slug == "planning/scenario-list" ||
        page.slug == "planning/schedule" ||
        page.slug == "planning" ? (
          <PlanningMenu />
        ) : null}
      </div>
    </aside>
  );
};

export default MobileTopMenu;
